import Student1 from '../../assets/Student1.png'
import Student2 from '../../assets/Student2.png'
import Student3 from '../../assets/Student3.png'
import Student4 from '../../assets/Student4.png'
import Student5 from '../../assets/Student5.png'
import Student6 from '../../assets/Student6.png'
import Student7 from '../../assets/Student7.png';

export const StudentReview = [
    {
        id: 1, 
        image: Student1,
        name: "Omolade",
        testimonial: "Learning with Ayodeji Omonijo in the beginners course was really nice. I really learnt a lot about UI/UX design and I was able to understand easily. It is a good place to learn and I recommend it to others who also want to learn effectively ",
        circleColor: "#428AF7"
    },
    {
        id: 2, 
        image: Student2,
        name: "Abisoye",
        testimonial: "It was fun, educative and entertaining. The teachings were so easy to understand and Ayodeji was always ready to answer any question.",
        circleColor: "#F7424D"
    },
    {
        id: 3, 
        image: Student3,
        name: "Ubah Arinze",
        testimonial: "It was awesome, I highly recommend.",
        circleColor: "#42F754"
    },
    {
        id: 4, 
        image: Student4,
        name: "Ridwan",
        testimonial: "The experience was so fantastic and effective, I once found UIUX as a hard not to crack but when I met Ayodeji, he made it more easier. He started from the scratch and gave me some examples with live practical videos. I gallantly recommend his course to everyone who wants to learn UIUX to some extent. You will not regret the experience with him",
        circleColor: "#F7CF42"
    },
    {
        id: 5, 
        image: Student5,
        name: "Rasheedat",
        testimonial: "The course is a very good one. It breaks down everything a beginner needs to know into bite size and easy to understand concept. You can never go wrong with the course.",
        circleColor: "#42ECF7"
    },
    {
        id: 6, 
        image: Student6,
        name: "Peter",
        testimonial: "It's been very amazing as the tutor takes out time to make sure all students are up to date with his classes. The amount of professionalism put into his videos and the content are simply astounding too. Anyone can learn well with him!! ",
        circleColor: "#CD2B5E"
    },
    {
        id: 7, 
        image: Student7,
        name: "Kingsley",
        testimonial: "Great and easy to comprehend, the only challenges I encountered was data issues",
        circleColor: "#F6CF42"
    },
    // {
    //     id: 8, 
    //     image: Image,
    //     name: "Martins",
    //     testimonial: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Odio lobortis malesuada eu ultricies. Scelerisque dignissim tellus magnis libero aliquet urna, cras quis. Velit etiam scelerisque vitae proin morbi vitae.",
    //     circleColor: "#DDF742"
    // },
    // {
    //     id: 9, 
    //     image: Image,
    //     name: "Martins",
    //     testimonial: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Odio lobortis malesuada eu ultricies. Scelerisque dignissim tellus magnis libero aliquet urna, cras quis. Velit etiam scelerisque vitae proin morbi vitae.",
    //     circleColor: "#BD42F7"
    // },

]